import { render, staticRenderFns } from "./ReportErrorMessage.vue?vue&type=template&id=12d9325b&scoped=true&"
import script from "./ReportErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ReportErrorMessage.vue?vue&type=script&lang=js&"
import style0 from "./ReportErrorMessage.vue?vue&type=style&index=0&id=12d9325b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d9325b",
  null
  
)

export default component.exports